import ForecasterDateTab from '@/Enums/Forecaster/DateTab.enum';

export const EstimationTabLabels: Record<ForecasterDateTab, string> = {
  [ForecasterDateTab.Week]: 'Weekly',
  [ForecasterDateTab.Day]: 'Daily',
  [ForecasterDateTab.Month]: 'Monthly',
  [ForecasterDateTab.Custom]: 'Custom',
};
